export default __webpack_public_path__ + "static/media/ganesh.795d072a.jpg";